import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AutomobileYear } from './automobile-year';

@inheritSerialization(AbstractModel)
export class AutomobileMake extends AbstractModel {
  @autoserialize
  name: string;

  @autoserializeAs(AutomobileYear)
  automobileYears: Array<AutomobileYear>;
}
